export default "__VITE_ASSET__ae66db0d__"